import { TailwindCustomConfig } from '@alliance/santa/tailwind'
import { logoHelper, logoHelperLong } from '../configs/logos-helper'
import { RxStateComponent } from '@alliance/shared/models'
import { MediaService } from '@alliance/shared/utils'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { map } from 'rxjs'
import { Translations } from '../localization/translations'

@Component({
  selector: 'alliance-ats-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent extends RxStateComponent<{ width: number }> {
  @Input() public full = false

  public readonly LogoHelper = logoHelper
  public readonly LogoHelperLong = logoHelperLong
  public readonly state = this.connectViewState(['width'])
  public constructor(public translations: Translations, private mediaService: MediaService) {
    super()
    this.initState({
      width: this.mediaService.getScreen$(TailwindCustomConfig.THEME.screens['1000']).pipe(map(v => (v ? 85 : 120)))
    })
  }
}
